export const tr = {
    noticeMessageSuccess: {
        one: '{count} grup seçilen kampanyalara kopyalandı',
        some: '{count} grup seçilen kampanyalara kopyalandı',
        many: '{count} grup seçilen kampanyalara kopyalandı',
        none: '{count} grup seçilen kampanyalara kopyalandı'
    },
    noticeMessageSuccessOneCampaign: {
        one: '{count} reklam grubu {campaignId} numaralı kampanyaya eklendi',
        some: '{count} reklam grubu {campaignId} numaralı kampanyaya eklendi',
        many: '{count} reklam grubu {campaignId} numaralı kampanyaya eklendi',
        none: '{count} reklam grubu {campaignId} numaralı kampanyaya eklendi'
    },
    noticeSingleGroupNoticeMessage: '{id} numaralı grup seçilen kampanyalara kopyalandı',
    noticeSingleGroupSingleCampaignMessage: '{id} numaralı grup {campaignId} numaralı kampanyaya kopyalandı\r'
};
